import React from 'react';
import { Page } from '../Common/Components/Page';
import { UserMappingsContent } from './Components/UserMappingsContent';

export const UserMappings = (): React.JSX.Element => (
  <Page title="User Roles" accessKey={'roles'} isSearchable={false}>
    <UserMappingsContent />
  </Page>
);
